import React, { useState } from 'react';
import {
  Typography,
  Box,
  Paper,
  Button,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { useSetAtom, useAtom, useAtomValue } from 'jotai';
import { isBackdropOpenAtom, pageAtom, snackbarPropsAtom } from '../../atoms';
import { PAGE } from '../../constant/page';
import { ApiAccountsAccept } from '../../api/apiAccountsAccept';
import TeamsOfUseBox from './components/termsOfUseBox';
import { loadableTermsOfUseAtom } from '../../atoms/termsOfUseAtoms';

const boxStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '80px',
};

const paperStyles = {
  width: '50%',
  maxWidth: '700px',
  paddingX: '100px',
  paddingY: '50px',
};

const TermsOfUsePage = () => {
  const [isAgreement, setIsAgreement] = useState(false);
  const [page, setPage] = useAtom(pageAtom);
  const termsOfUse = useAtomValue(loadableTermsOfUseAtom);
  const setIsBackdropOpen = useSetAtom(isBackdropOpenAtom);
  const setSnackbarProps = useSetAtom(snackbarPropsAtom);

  const onClickAgreeTerms = () => {
    if (page === PAGE.TERMS_OF_USE) {
      setPage(PAGE.REGISTRATION);
      return;
    }

    setIsBackdropOpen(true);
    ApiAccountsAccept.put()
      .then(() => {
        setPage(PAGE.MAIN);
      })
      .catch(() => {
        setSnackbarProps({
          isOpen: true,
          message: 'サーバーとの通信に失敗しました。',
          type: 'error',
        });
      })
      .finally(() => {
        setIsBackdropOpen(false);
      });
  };

  return (
    <Box {...boxStyles}>
      <Paper elevation={3} sx={paperStyles}>
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          gap='50px'
        >
          <Typography variant='h4' color={'#007DC5'}>
            {'Topconect 利用規約'}
          </Typography>

          <Box
            width={'100%'}
            height={'300px'}
            display='flex'
            flexDirection='column'
            alignItems='center'
          >
            <TeamsOfUseBox />
          </Box>
          <FormControlLabel
            label={'利用規約に同意する'}
            control={
              <Checkbox
                disabled={termsOfUse.state !== 'hasData'}
                checked={isAgreement}
                onChange={() => {
                  setIsAgreement(!isAgreement);
                }}
              />
            }
          />

          <Box
            display={'flex'}
            justifyContent={'center'}
            columnGap={5}
            marginBottom={5}
          >
            <Button
              variant='contained'
              sx={{ width: '150px' }}
              color='inherit'
              onClick={() => {
                setPage(PAGE.LOGIN);
              }}
            >
              戻る
            </Button>
            <Button
              variant='contained'
              sx={{ width: '150px' }}
              color='primary'
              disabled={!isAgreement}
              onClick={onClickAgreeTerms}
            >
              次へ
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default React.memo(TermsOfUsePage);
